const ITEMS = [
  "JCI-Accredited Hospitals",
  "Harvard & Oxford-Trained Surgeons",
  "80% Average Cost Savings",
  "24/7 Dedicated Care Manager",
  "Five-Star Resort Recovery",
  "Seamless Visa & Flight Concierge",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-gold/25 bg-brand-green py-5" data-testid="accreditation-marquee">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-[11px] uppercase tracking-[0.28em] text-ivory/85">
            <span className="px-8">{item}</span>
            <span className="text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
